var map = {
	"./Avineon.jpg": 135,
	"./BI.png": 136,
	"./KPMG-Logo.png": 137,
	"./Power Bi.png": 138,
	"./Tableau.png": 139,
	"./WF.png": 140,
	"./Wipro.jpg": 141,
	"./address_image.svg": 142,
	"./animated_logo.svg": 143,
	"./blogs_image.svg": 144,
	"./cloud_infrastructure.svg": 145,
	"./codeInLogo.png": 146,
	"./contactMail.png": 147,
	"./coursera_logo.png": 148,
	"./data_science.svg": 149,
	"./deeplearning_ai_logo.png": 150,
	"./delhivery_logo.png": 151,
	"./developerActivity.svg": 152,
	"./dsc_logo.png": 153,
	"./education.svg": 154,
	"./experience.svg": 155,
	"./feelingProud.svg": 156,
	"./freecopy_logo.png": 157,
	"./fullstack.svg": 158,
	"./gcp_logo.png": 159,
	"./github_logo.png": 160,
	"./googleAssistant.jpg": 161,
	"./googleAssistant.svg": 162,
	"./google_logo.png": 163,
	"./ibm_logo.png": 164,
	"./intel_logo.jpg": 165,
	"./jsFramework.svg": 166,
	"./linkedin.png": 167,
	"./manOnTable.svg": 168,
	"./microsoft_logo.png": 169,
	"./mvit-img.png": 170,
	"./portfolio.gif": 171,
	"./programmer.svg": 172,
	"./projects_image.svg": 173,
	"./pwa.png": 174,
	"./saayaHealthLogo.png": 175,
	"./talksCardBack.svg": 176,
	"./talksCardBackAlt.svg": 177,
	"./ui_ux_design.svg": 178,
	"./yash rao.png": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;